// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Dashboard Header Styles
 * Consistent header layout for both Admin and User dashboards
 */

/* Unified Dashboard Header */
.unified-dashboard-header {
    background: radial-gradient(circle at 20% 80%, rgba(234, 88, 12, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(253, 186, 116, 0.1) 0%, transparent 50%), linear-gradient(135deg, #EA580C, #FDBA74);
    color: white;
    padding: 0;
    margin: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 1000;
}

.unified-dashboard-header-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 80px;
}

/* Title Section */
.unified-dashboard-title-section {
    display: flex;
    align-items: center;
    gap: 16px;
}

.unified-dashboard-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.unified-dashboard-icon .icon {
    font-size: 28px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.unified-dashboard-title-info h2 {
    margin: 0;
    font-size: 2rem;
    font-weight: 700;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    line-height: 1.2;
}

.unified-dashboard-title-info p {
    margin: 4px 0 0 0;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 400;
    line-height: 1.3;
}

/* Actions Section */
.unified-dashboard-actions-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

/* User Menu Container */
.unified-user-menu-container {
    position: relative;
}

.unified-user-profile {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    min-width: 200px;
}

.unified-user-profile:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.unified-user-profile.active {
    background: rgba(255, 255, 255, 0.25);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* User Avatar */
.unified-user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.3);
    flex-shrink: 0;
}

.avatar-text {
    font-size: 18px;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* User Details */
.unified-user-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 1;
    min-width: 0;
}

.unified-user-name {
    font-size: 1rem;
    font-weight: 600;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
}

.unified-user-email {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.8);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
}

/* Dropdown Arrow */
.unified-dropdown-arrow {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    transition: transform 0.3s ease;
    flex-shrink: 0;
}

.unified-dropdown-arrow.open {
    transform: rotate(180deg);
}

/* Dropdown Menu */
.unified-user-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    z-index: 1001;
    animation: slideDown 0.3s ease;
}

.unified-dropdown-menu {
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.05);
    padding: 8px;
    min-width: 160px;
    backdrop-filter: blur(10px);
}

.unified-dropdown-menu .btn {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease;
}

.unified-dropdown-menu .btn:hover {
    background: rgba(13, 59, 102, 0.1);
    color: #0D3B66;
    transform: translateX(2px);
}

/* Animations */
@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .unified-dashboard-header-content {
        padding: 0 20px;
        min-height: 70px;
    }

    .unified-dashboard-title-info h2 {
        font-size: 1.5rem;
    }

    .unified-dashboard-title-info p {
        font-size: 0.85rem;
    }

    .unified-dashboard-icon {
        width: 50px;
        height: 50px;
    }

    .unified-dashboard-icon .icon {
        font-size: 24px;
    }

    .unified-user-profile {
        min-width: 160px;
        padding: 6px 12px;
    }

    .unified-user-avatar {
        width: 36px;
        height: 36px;
    }

    .avatar-text {
        font-size: 14px;
    }

    .unified-user-name {
        font-size: 0.85rem;
    }

    .unified-user-email {
        font-size: 0.75rem;
    }
}

@media (max-width: 480px) {
    .unified-dashboard-header-content {
        padding: 0 15px;
        min-height: 60px;
    }

    .unified-dashboard-title-section {
        gap: 12px;
    }

    .unified-dashboard-title-info h2 {
        font-size: 1.25rem;
    }

    .unified-dashboard-title-info p {
        font-size: 0.8rem;
    }

    .unified-dashboard-icon {
        width: 45px;
        height: 45px;
    }

    .unified-dashboard-icon .icon {
        font-size: 20px;
    }

    .unified-user-profile {
        min-width: 140px;
        padding: 4px 8px;
        gap: 8px;
    }

    .unified-user-avatar {
        width: 32px;
        height: 32px;
    }

    .avatar-text {
        font-size: 12px;
    }

    .unified-user-name {
        font-size: 0.8rem;
    }

    .unified-user-email {
        font-size: 0.7rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedDashboardHeader.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,6BAA6B;AAC7B;IACI,uNAAuN;IACvN,YAAY;IACZ,UAAU;IACV,SAAS;IACT,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,mBAAmB;IACnB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,+BAA+B;IAC/B,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/**\n * Unified Dashboard Header Styles\n * Consistent header layout for both Admin and User dashboards\n */\n\n/* Unified Dashboard Header */\n.unified-dashboard-header {\n    background: radial-gradient(circle at 20% 80%, rgba(234, 88, 12, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(253, 186, 116, 0.1) 0%, transparent 50%), linear-gradient(135deg, #EA580C, #FDBA74);\n    color: white;\n    padding: 0;\n    margin: 0;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    position: relative;\n    z-index: 1000;\n}\n\n.unified-dashboard-header-content {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 80px;\n}\n\n/* Title Section */\n.unified-dashboard-title-section {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.unified-dashboard-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 60px;\n    height: 60px;\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 16px;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.unified-dashboard-icon .icon {\n    font-size: 28px;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.unified-dashboard-title-info h2 {\n    margin: 0;\n    font-size: 2rem;\n    font-weight: 700;\n    color: white;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    line-height: 1.2;\n}\n\n.unified-dashboard-title-info p {\n    margin: 4px 0 0 0;\n    font-size: 1rem;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 400;\n    line-height: 1.3;\n}\n\n/* Actions Section */\n.unified-dashboard-actions-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n/* User Menu Container */\n.unified-user-menu-container {\n    position: relative;\n}\n\n.unified-user-profile {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 16px;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 12px;\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n    min-width: 200px;\n}\n\n.unified-user-profile:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.unified-user-profile.active {\n    background: rgba(255, 255, 255, 0.25);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* User Avatar */\n.unified-user-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    flex-shrink: 0;\n}\n\n.avatar-text {\n    font-size: 18px;\n    font-weight: 600;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* User Details */\n.unified-user-details {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-width: 0;\n}\n\n.unified-user-name {\n    font-size: 1rem;\n    font-weight: 600;\n    color: white;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.2;\n}\n\n.unified-user-email {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.8);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.2;\n}\n\n/* Dropdown Arrow */\n.unified-dropdown-arrow {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.8);\n    transition: transform 0.3s ease;\n    flex-shrink: 0;\n}\n\n.unified-dropdown-arrow.open {\n    transform: rotate(180deg);\n}\n\n/* Dropdown Menu */\n.unified-user-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 8px;\n    z-index: 1001;\n    animation: slideDown 0.3s ease;\n}\n\n.unified-dropdown-menu {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    padding: 8px;\n    min-width: 160px;\n    backdrop-filter: blur(10px);\n}\n\n.unified-dropdown-menu .btn {\n    width: 100%;\n    justify-content: flex-start;\n    gap: 8px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.unified-dropdown-menu .btn:hover {\n    background: rgba(13, 59, 102, 0.1);\n    color: #0D3B66;\n    transform: translateX(2px);\n}\n\n/* Animations */\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .unified-dashboard-header-content {\n        padding: 0 20px;\n        min-height: 70px;\n    }\n\n    .unified-dashboard-title-info h2 {\n        font-size: 1.5rem;\n    }\n\n    .unified-dashboard-title-info p {\n        font-size: 0.85rem;\n    }\n\n    .unified-dashboard-icon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .unified-dashboard-icon .icon {\n        font-size: 24px;\n    }\n\n    .unified-user-profile {\n        min-width: 160px;\n        padding: 6px 12px;\n    }\n\n    .unified-user-avatar {\n        width: 36px;\n        height: 36px;\n    }\n\n    .avatar-text {\n        font-size: 14px;\n    }\n\n    .unified-user-name {\n        font-size: 0.85rem;\n    }\n\n    .unified-user-email {\n        font-size: 0.75rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-dashboard-header-content {\n        padding: 0 15px;\n        min-height: 60px;\n    }\n\n    .unified-dashboard-title-section {\n        gap: 12px;\n    }\n\n    .unified-dashboard-title-info h2 {\n        font-size: 1.25rem;\n    }\n\n    .unified-dashboard-title-info p {\n        font-size: 0.8rem;\n    }\n\n    .unified-dashboard-icon {\n        width: 45px;\n        height: 45px;\n    }\n\n    .unified-dashboard-icon .icon {\n        font-size: 20px;\n    }\n\n    .unified-user-profile {\n        min-width: 140px;\n        padding: 4px 8px;\n        gap: 8px;\n    }\n\n    .unified-user-avatar {\n        width: 32px;\n        height: 32px;\n    }\n\n    .avatar-text {\n        font-size: 12px;\n    }\n\n    .unified-user-name {\n        font-size: 0.8rem;\n    }\n\n    .unified-user-email {\n        font-size: 0.7rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
